import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	aboutus: [],
};

// active account slice
export const aboutUsSlice = createSlice({
	name: 'aboutus',
	initialState,
	reducers: {
		setAboutUs: (state, action) => {
			state.aboutus = action.payload;
		},
	},
});

export const {
	setAboutUs,
} = aboutUsSlice.actions;

export default aboutUsSlice.reducer;
